<mat-card *appHasRoles="['admin', 'manager', 'agent', 'compliance']" class="content-card">
  <mat-card-header>
    <mat-card-title>
      <h5>🏦 MicroPayment Sessions</h5>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>

    <ng-container *ngIf="isLoading">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </ng-container>
    <ng-container *ngIf="!isLoading && sessions">

      <div class="list-item" fxLayout="row" fxLayoutGap="10px" >
        <label fxFlex="15" class="secondary">Date</label>
        <label fxFlex="21" class="secondary">Reference</label>
        <label fxFlex="45" class="secondary">Type</label>
      </div>
      <div id="scroll">
        <div class="list-item" fxLayout="row" fxLayoutGap="10px" *ngFor="let inv of sessions" >
          <label class="" fxFlex="15" >{{ inv.createDate | date: "dd.MM.yyyy HH:mm" }}</label>
          <label class="" fxFlex="21" style="font-family: monospace;">{{ inv.payText }}</label>
          <label class="" fxFlex="45" style="font-family: monospace;">{{ inv.sessionId }}</label>
        </div>
      </div>
    </ng-container>
    <div class="text-center mt-1 mb-1 w-100" *ngIf="!isLoading && (!sessions || sessions.length == 0)">
      <i>- none- </i>
    </div>
  </mat-card-content>
</mat-card>
